// 当前页，目前主要是用来区分相同路由下不同子页面，用来做pageSize本次存储的区分
window.currentTablePage = '' as TablePageName;
